import { Pipe, PipeTransform } from '@angular/core';
import { ISystemDetails } from '../../models/common.models';
import { IPurchaseActivitySystemDetails } from '../../features/purchase-activity/data/purchase-activity.models';
import { IRfQSystemDetails } from '../../models/rfq.models';

type SystemDetailsUnion = ISystemDetails | IPurchaseActivitySystemDetails | IRfQSystemDetails;

@Pipe({
  name: 'companyDetails',
  standalone: false,
})
export class CompanyDetailsPipe implements PipeTransform {
  transform(systemDetails: SystemDetailsUnion): any {
    if (!systemDetails) {
      return '';
    }

    const companyPart: string = systemDetails.company ? `${systemDetails.company} - ` : '';
    const companyBuPart: string = systemDetails.companyBusinessUnit || '';
    const companyBuNumberPart: string = systemDetails.companyBusinessUnitNumber ?
      ` (${systemDetails.companyBusinessUnitNumber})` : '';

    return `${companyPart}${companyBuPart}${companyBuNumberPart}`;
  }
}
